import { cn } from './chunk-FFX3LZW7.js';
import { cva } from 'class-variance-authority';
import { jsx } from 'react/jsx-runtime';

var badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive text-destructive-foreground",
        outline: "text-foreground",
        brand: "border-transparent bg-brand text-brand-foreground"
      }
    },
    defaultVariants: { variant: "default" }
  }
);
function Badge({ className, variant, ...props }) {
  return /* @__PURE__ */ jsx("div", { className: cn(badgeVariants({ variant }), className), ...props });
}

export { Badge, badgeVariants };
//# sourceMappingURL=chunk-S775MXMS.js.map
//# sourceMappingURL=chunk-S775MXMS.js.map